// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_IsriD","dangerous":"view-default_dangerous_2DUc5"};